import styled from "styled-components"
import {Col} from "react-bootstrap"

import media from "@irati/ui/src/global/media"

const ColWithPadding = styled(Col)`
  padding: ${({theme}) => theme.spacing.two} 0;
  ${media.tablet`
    padding-bottom: 0;
  `}
`

export default ColWithPadding
